import React from 'react';
import { useDashboard } from '../../contexts/DashboardContext';

const AppointmentDetailsModal = () => {
  const {
    formatTableDate, formatTableTime, selectedAppointmentDetails,
    setSelectedAppointmentDetails, setShowAppointmentDetails, showAppointmentDetails,
  } = useDashboard();

  if (!showAppointmentDetails || !selectedAppointmentDetails) return null;

  return (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[150]">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-[95vw] md:max-w-2xl overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center bg-gray-700">
                <h3 className="text-lg font-semibold text-white">Appointment Details</h3>
                <button
                  onClick={() => {
                    setShowAppointmentDetails(false);
                    setSelectedAppointmentDetails(null);
                  }}
                  className="text-white hover:text-gray-300"
                >
                  ✕
                </button>
              </div>
              
              <div className="px-6 py-4 space-y-4">
                {/* Client Information */}
                <div>
                  <h4 className="text-sm font-semibold text-gray-700 mb-2">Client Information</h4>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-xs text-gray-500">Client Name</p>
                      <p className="text-sm font-medium text-gray-900">{selectedAppointmentDetails.client_name}</p>
                    </div>
                    {!selectedAppointmentDetails.isGoogleEvent && selectedAppointmentDetails.service_type && (
                      <div>
                        <p className="text-xs text-gray-500">Service Type</p>
                        <p className="text-sm font-medium text-gray-900">
                          {serviceTypes.find(s => s.value === selectedAppointmentDetails.service_type)?.label || selectedAppointmentDetails.service_type}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Property Information */}
                {!selectedAppointmentDetails.isGoogleEvent && selectedAppointmentDetails.property_address && (
                  <div>
                    <h4 className="text-sm font-semibold text-gray-700 mb-2">Property Information</h4>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-xs text-gray-500">Property Address</p>
                        <p className="text-sm font-medium text-gray-900">{selectedAppointmentDetails.property_address}</p>
                      </div>
                      {selectedAppointmentDetails.property_size && (
                        <div>
                          <p className="text-xs text-gray-500">Property Size</p>
                          <p className="text-sm font-medium text-gray-900">{selectedAppointmentDetails.property_size} sq ft</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Schedule Information */}
                <div>
                  <h4 className="text-sm font-semibold text-gray-700 mb-2">Schedule</h4>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <p className="text-xs text-gray-500">Date</p>
                      <p className="text-sm font-medium text-gray-900">{formatTableDate(selectedAppointmentDetails.scheduled_date)}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Time</p>
                      <p className="text-sm font-medium text-gray-900">{formatTableTime(selectedAppointmentDetails.scheduled_time)}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Duration</p>
                      <p className="text-sm font-medium text-gray-900">{selectedAppointmentDetails.duration_minutes} min</p>
                    </div>
                  </div>
                </div>

                {/* Status */}
                <div>
                  <h4 className="text-sm font-semibold text-gray-700 mb-2">Status</h4>
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    selectedAppointmentDetails.status === 'completed' ? 'bg-green-100 text-green-800' :
                    selectedAppointmentDetails.status === 'in_progress' ? 'bg-blue-100 text-blue-300' :
                    selectedAppointmentDetails.status === 'scheduled' ? 'bg-yellow-100 text-yellow-300' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {selectedAppointmentDetails.status.replace('_', ' ').toUpperCase()}
                  </span>
                </div>

                {/* Photographer */}
                {!selectedAppointmentDetails.isGoogleEvent && selectedAppointmentDetails.photographer_name && (
                  <div>
                    <h4 className="text-sm font-semibold text-gray-700 mb-2">Photographer</h4>
                    <p className="text-sm font-medium text-gray-900">{selectedAppointmentDetails.photographer_name}</p>
                  </div>
                )}

                {/* Google Event Note */}
                {selectedAppointmentDetails.isGoogleEvent && (
                  <div className="bg-blue-50 p-3 rounded-lg">
                    <p className="text-sm text-blue-300">
                      📅 This is a Google Calendar event
                    </p>
                  </div>
                )}
              </div>

              <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end">
                <button
                  onClick={() => {
                    setShowAppointmentDetails(false);
                    setSelectedAppointmentDetails(null);
                  }}
                  className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
  );
};

export default AppointmentDetailsModal;
